import React, { Component, createRef, Fragment } from "react";
import { connect } from "react-redux";
import * as queryString from "query-string";
import { isEmpty } from "lodash";
import { fromJS } from "immutable";
import { bindActionCreators } from "redux";
import { ActionCreator } from "actions";
import "containers/ShowMoreDesktop/Games/styles.scss";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import { CommonHeaderDesktop } from "component/common";
import {
  CategoryType8ListItem,
  IconCategoryListItem,
} from "component/listItem";
import { ReactComponent as PreviousIcon } from "assets/icons/previous.svg";
import { CategoryGames } from "component/list";
import translations from "translations";
import ShowMoreFilters from "containers/ShowMoreFilters";
import { CategoryFiltersComponent } from "component/filters";

const SEE_ALL_MODAL = "SEE_ALL_MODAL";
class ShowMoreGamesDesktop extends Component {
  constructor(props) {
    super(props);
    this.seeMoreRef = createRef();
    this.onGameItemClickHandler = this._onGameItemClickHandler.bind(this);
    this.handleScroll = this._handleScroll.bind(this);
    this.onClickPrevious = this._onClickPrevious.bind(this);
    this.onApplyFilterClickHandler = this._onApplyFilterClickHandler.bind(this);
    this.state = {
      skeleton: [1, 2, 3, 4, 5, 6],
      games: null,
      showCategoryLabel: false,
      startsIn: null,
      endsIn: null,
      supportingText: null,
      activeFilter: null,
    };
  }

  _onClickPrevious() {
    this.props.goBack(
      `${this.props.location.pathname}${this.props.location.search}`
    );
    this.props.history.goBack();
  }

  _onFilterClickHandler(subCategory, value) {
    this.props.setActiveFilter(this.props.filtersRoute, subCategory, value);
  }

  _onFilterClearHandler(subCategory) {
    this.props.clearFilterByCategory(
      this.props.filterRoute.get("rel"),
      subCategory
    );
  }

  _onApplyFilterClickHandler() {
    this.props.showFilters(!this.props.filtersVisible);
  }

  _onGameItemClickHandler(game, rel) {
    let gameId = game.get("gameId");
    let nav = this.props.link
      ? this.props.link.get("rel").replace("show.more.", "")
      : null;
    this.props.gameClick(gameId, rel, nav).then((response) => {
      if (response.location) {
        this.props.navigateTo(response.location);
      } else if (response.params) {
        this.props.setGameAction(response.params);
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.showMoreRel !== this.props.showMoreRel) {
      if (!nextProps.showMoreRel) {
        this.props.hideModal(SEE_ALL_MODAL);
      } else {
        this.props.showModal(SEE_ALL_MODAL);
      }
    }

    if (nextProps.games) {
      this.setState({ supportingText: nextProps.games.get("supportingText") });
    }
  }

  renderSeeAllListItem(game, key) {
    let linkDemo = game.get("links").find((link) => {
      return link.get("rel") === "launch.demo";
    });
    let linkReal = game.get("links").find((link) => {
      return link.get("rel") === "launch.real";
    });
    let linkDetails = game.get("links").find((link) => {
      return link.get("rel") === "game.details";
    });

    let ListItem;
    switch (this.props.showMoreRel) {
      case "show.more.categories-home.recentlyplayed":
        ListItem = IconCategoryListItem;
        break;
      case "show.more.play-it-again":
        ListItem = IconCategoryListItem;
        break;
      default:
        ListItem = CategoryType8ListItem;
        break;
    }

    return (
      <ListItem
        key={key}
        game={game}
        linkDemo={linkDemo}
        linkReal={linkReal}
        linkDetails={linkDetails}
        host={this.props.host}
        isMobile={this.props.isMobile}
        onClick={(rel) => {
          if (linkReal && this.props.isOneClickPlayEnabled)
            return this.onGameItemClickHandler(game, linkReal.get("rel"));
          if (linkDemo && this.props.isOneClickPlayEnabled)
            return this.onGameItemClickHandler(game, linkReal.get("rel"));
          return this.onGameItemClickHandler(game, rel);
        }}
        onShowActionClick={() => {
          this.launchActions(game);
        }}
        currency={this.props.currency}
        symbol={this.props.symbol}
        imageFormat={this.props.imageFormat}
        isOneClickPlayEnabled={this.props.isOneClickPlayEnabled}
      />
    );
  }

  _handleScroll() {
    const scrollDemo = document.querySelector(".show-more-games-desktop-modal");
    if (scrollDemo.scrollTop !== 0) {
      this.setState({ showCategoryLabel: true });
    } else {
      this.setState({ showCategoryLabel: false });
    }
  }

  resize2fit(elements) {
    elements.forEach((el) => {
      if (!el.parentElement) return;

      el.style.setProperty("--font-size", "1.5em");
      const {
        width: max_width,
        height: max_height,
      } = el.getBoundingClientRect();
      const { width, height } = el.children[0].getBoundingClientRect();
      el.style.setProperty(
        "--font-size",
        Math.min(max_width / width, max_height / height) + "em"
      );
    });
  }

  render() {
    const { route } = this.props;
    const isTournamentView =
      this.props.showMoreRel.indexOf("tournament-games") > -1;
    const isJackpotView = this.props.showMoreRel.indexOf("jackpot-games") > -1;
    let ListItem;
    switch (this.props.showMoreRel) {
      case "show.more.categories-home.recentlyplayed":
      case "categories-home.recentlyplayed":
        ListItem = IconCategoryListItem;
        break;
      case "show.more.play-it-again":
        ListItem = IconCategoryListItem;
        break;
      default:
        ListItem = CategoryType8ListItem;
        break;
    }

    if (!this.props.showMoreRel) return null;

    this.resize2fit(document.querySelectorAll(".prize-container"));

    return (
      <Fragment>
        <div
          ref={this.seeMoreRef}
          className={`show-more-games-desktop-modal ${
            this.state.isSpecialCategory ? "s-categories" : ""
          } ${isTournamentView ? "tournament-show-more" : ""} `}
          onScroll={this.handleScroll}
        >
          {route && (
            <div className="header">
              <CommonHeaderDesktop
                link={route}
                showCategoryLabel={this.state.showCategoryLabel}
                detailsAvailable={this.props.detailsAvailable}
                isJackpotView={isJackpotView}
                onInfoClick={() => {
                  let params = this.props.qs;
                  params.tournamentDetails = route.get("rel");

                  let newLoc = `${
                    this.props.location.pathname
                  }?${queryString.stringify(params)}`;
                  this.props.navigateTo(newLoc);
                }}
                leftPanel={() => {
                  return (
                    <span
                      className="float-left prev-btn"
                      onClick={this.onClickPrevious}
                    >
                      <PreviousIcon width="34" />
                    </span>
                  );
                }}
                rightPanel={() => {
                  return (
                    <CloseIcon
                      width="34"
                      onClick={() => {
                        this.props.navigateTo(this.props.location.pathname);
                      }}
                    />
                  );
                }}
              />
            </div>
          )}
          <div className="content">
            {!this.props.tournamentPreview && (
              <Fragment>
                {route && (
                  <Fragment>
                    <span
                      className={`label ${
                        route.get("name").includes("Claim Your Rewards") ||
                        route.get("name").includes("领取奖励") ||
                        route.get("name").includes("報酬獲得")
                          ? "rewards"
                          : ""
                      }`}
                    >
                      {route.get("name")}
                    </span>
                    {this.props.status === "OPEN" && (
                      <span className="status open">
                        {translations("comingSoon")}
                      </span>
                    )}
                    {this.props.status === "IN_PROGRESS" && (
                      <span className="status inprogress">
                        {translations("ongoing")}
                      </span>
                    )}
                    {this.props.status === "COMPLETED" && (
                      <span className="status completed">
                        {translations("expired")}
                      </span>
                    )}
                  </Fragment>
                )}
                {!route && (
                  <Fragment>
                    <div className="label">
                      <span className="dummy">XXXXXXXXXXX</span>
                    </div>
                    {isTournamentView && (
                      <div className="sub">
                        <span className="dummy">XXXXXXXX</span>
                      </div>
                    )}
                  </Fragment>
                )}
              </Fragment>
            )}

            <CategoryFiltersComponent
              filters={this.props.filters}
              filterRoute={this.props.filtersRoute}
              fetchFilters={(route) => {
                let params = new URLSearchParams();
                if (this.props.filters) {
                  this.props.filters.forEach((filter) => {
                    //if(filter.get('id') !== "providers") {
                    filter.get("values").forEach((value) => {
                      if (value.get("toggled") === true) {
                        params.append(filter.get("id"), value.get("id"));
                      }
                    });
                    //}
                  });
                }
                this.props.clearGames(this.props.route);
                this.props.fetchFilters(route, params);
              }}
              onApplyFilterClickHandler={(filter) => {
                this.onApplyFilterClickHandler();
                let filterId =
                  filter.get("id") === "gameType"
                    ? "category"
                    : filter.get("id");
                this.setState({
                  activeFilter: filterId,
                });
              }}
              onSortClick={() => {
                this.onApplyFilterClickHandler();
                this.setState({
                  activeFilter: "sortBy",
                });
              }}
              onFilterClickHandler={this.props.setActiveFilter}
              showSelectedFilter={true}
              games={this.props.games}
              link={this.props.route}
              sortBy={this.props.sortBy}
              sorts={this.props.sorts}
              enableClearAll={this.props.enableClearAll}
              clearAllFilters={this.props.clearAllFilters}
              isMobile={this.props.isMobile}
              sortingSize={this.props.sortingSize}
              filtersIsLoading={this.props.filtersIsLoading}
            />

            {this.state.supportingText && (
              <div className={"game-count"}>{this.state.supportingText}</div>
            )}
            <CategoryGames
              route={this.props.route}
              hasNoFilters={!this.props.filtersRoute}
              refreshList={!this.props.filtersIsLoading}
              itemComponent={ListItem}
              isMobile={this.props.isMobile}
              isLoading={this.props.isLoading}
              isLoadingNext={this.props.isLoadingNext}
              hasNextPage={this.props.hasNextPage}
              games={this.props.games}
              sortBy={this.props.sortBy}
              currency={this.props.currency}
              fetchGames={() => {
                let params = new URLSearchParams();
                if (this.props.filters) {
                  this.props.filters.forEach((filter) => {
                    filter.get("values").forEach((value) => {
                      if (value.get("toggled") === true) {
                        params.append(filter.get("id"), value.get("id"));
                      }
                    });
                  });
                }
                if (this.props.sortBy) {
                  params.append("sortBy", this.props.sortBy);
                }

                if (this.props.size) {
                  params.append("size", this.props.size);
                }

                return this.props.fetchGames(this.props.route, params);
              }}
              onGameItemClickHandler={(game) => {
                let newGame = fromJS(game);
                let rel = newGame.get("playType");
                this.onGameItemClickHandler(newGame, rel);
              }}
              imageFormat={this.props.imageFormat}
              latestBroadcast={this.props.latestBroadcast}
              onReachEnd={() => {
                let params = new URLSearchParams();
                params.append("page", this.props.page + 1);

                if (this.props.filters) {
                  this.props.filters.forEach((filter) => {
                    filter.get("values").forEach((value) => {
                      if (value.get("toggled") === true) {
                        params.append(filter.get("id"), value.get("id"));
                      }
                    });
                  });
                }
                if (this.props.sortBy) {
                  params.append("sortBy", this.props.sortBy);
                }

                if (this.props.size) {
                  params.append("size", this.props.size);
                }

                return this.props.fetchGames(this.props.route, params);
              }}
              isOneClickPlayEnabled={this.props.isOneClickPlayEnabled}
            />
          </div>
        </div>
        <ShowMoreFilters
          refreshOnRouteChange={false}
          filtersIsLoading={this.props.filtersIsLoading}
          activeFilter={this.state.activeFilter}
          filters={this.props.filters}
          filtersLink={this.props.filtersRoute}
          sorts={this.props.sorts}
          games={this.props.games}
          onClose={() => {
            this.setState({
              activeFilter: null,
            });
          }}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let qs = queryString.parse(window.location.search);
  let { showMore, sub, status, route } = qs;
  let routeDecrypt = fromJS(JSON.parse(decodeURIComponent(atob(route))));
  let filtersRoute;
  let filtersIsLoading;
  let links;
  let games;
  let tournamentPreview;
  let isLoading = true;
  let isLoadingNext;
  let enableClearAll;
  let detailsAvailable = false;
  let subLink;
  let subGames;
  let currency = null;
  let filters;
  let sortBy;
  let sorts;
  let sortingSize = 0;
  let hasNextPage;
  let page;
  let size = 10;
  let latestBroadcast;

  try {
    latestBroadcast = state.serverSentEvent.getIn(["latestBroadcast"]);
  } catch (err) {}

  try {
    subLink = state.pages
      .getIn(["wl-pages", 0, "content"])
      .find((contentItem) => {
        return contentItem.get("rel") === sub;
      })
      .getIn(["links", 0]);
  } catch (err) {}
  try {
    subGames = state.games.getIn([sub]);
  } catch (err) {}
  try {
    games = state.games.getIn([showMore, "data"]);
  } catch (err) {}
  try {
    page = games.get("page");
  } catch (err) {}
  try {
    hasNextPage = games.get("totalPages") > games.get("page");
  } catch (err) {}
  try {
    isLoading = state.games.getIn([routeDecrypt.get("rel"), "isLoadingNext"]);
  } catch (err) {}
  try {
    size = games.get("size");
  } catch (err) {}
  try {
    tournamentPreview = state.tournaments.getIn([showMore]);
  } catch (err) {}
  try {
    isLoadingNext = state.games.getIn([
      routeDecrypt.get("rel"),
      "isLoadingNext",
    ]);
  } catch (err) {}
  try {
    detailsAvailable = state.games.getIn([
      routeDecrypt.get("rel"),
      "route",
      "links",
    ])
      ? true
      : false;
  } catch (err) {}

  try {
    filtersRoute = routeDecrypt.getIn(["links"]).find((link) => {
      return link.get("rel").indexOf("-filters") > -1;
    });
    filtersRoute = filtersRoute.setIn(
      ["rel"],
      `show.more.${filtersRoute.getIn(["rel"])}`
    );
  } catch (err) {}
  try {
    links = routeDecrypt.get("links");
  } catch (err) {}

  try {
    filters = state.filters.getIn([filtersRoute.get("rel"), "data", "filters"]);
  } catch (err) {}
  try {
    filtersIsLoading = state.filters.getIn([
      filtersRoute.get("rel"),
      "isLoading",
    ]);
  } catch (err) {}

  try {
    let toggledSize = 0;
    for (var i = 0; filters.size > i; i++) {
      toggledSize = filters.getIn([i, "toggledCount"]);
      sortingSize = sortingSize + toggledSize;
    }
  } catch (err) {}

  try {
    sorts = state.filters.getIn([filtersRoute.get("rel"), "data", "sorts"]);
  } catch (err) {}

  try {
    sortBy = state.filters.getIn([filtersRoute.get("rel"), "data", "sortBy"]);
  } catch (err) {}

  if (!isEmpty(state.links.get("currency"))) {
    currency = state.links.get("currency");
  }
  try {
    enableClearAll = state.filters.getIn([
      filtersRoute.get("rel"),
      "enableClearAll",
    ]);
  } catch (err) {}

  return {
    qs,
    subLink,
    subGames,
    status,
    currency: currency,
    detailsAvailable,
    showMoreRel: showMore,
    route: routeDecrypt,
    filtersRoute,
    filtersIsLoading,
    links,
    games,
    page,
    size,
    hasNextPage,
    tournamentPreview,
    isLoading,
    isLoadingNext,
    filters,
    sorts,
    sortBy,
    sortingSize,
    enableClearAll,
    latestBroadcast,
    isMobile: state.window.get("isMobile"),
    isMultiGame: state.links.get("isMultiGame"),
    imageFormat: state.window.get("imageFormat"),
    isOneClickPlayEnabled: state.links.get("isOneClickPlayEnabled"),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(ActionCreator, dispatch);
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, ownProps, {
    fetchFilters: (route, params) => dispatchProps.fetchFilters(route, params),
    setActiveFilter: (category, subCategory, filter) =>
      dispatchProps.setActiveFilter(category, subCategory, filter),
    clearFilterByCategory: (category, subcategory) =>
      dispatchProps.clearFilterByCategory(category, subcategory),
    fetchGames: (route, params) => dispatchProps.fetchGames(route, params),
    clearGames: (route) => dispatchProps.clearGames(route),
    navigateTo: (path) => ownProps.history.push(path),
    showModal: (modal) => dispatchProps.showModal(modal),
    hideModal: (modal) => dispatchProps.hideModal(modal),
    goBack: (url) => dispatchProps.goBack(url),
    showFilters: (bol) => dispatchProps.showFilters(bol),
    clearAllFilters: (category) => dispatchProps.clearAllFilters(category),
    gameClick: (gameId, playType, nav) =>
      dispatchProps.gameClick(gameId, playType, nav),
  });
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ShowMoreGamesDesktop);
